var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',[_c('oil-cap',{attrs:{"title":"ДОВЕРЕННОСТИ","buttons":[
      {
        route: 'procuration-create',
        name: 'Добавить Доверенность'.toUpperCase()
      }
    ],"service-name":"empowerment","search-filter":_vm.onSearchValueChange}}),_c('v-divider',{staticClass:"my-2"}),_c('oil-table',{attrs:{"hide-footer":true,"item-counts":_vm.empowerments.length+1,"keys":[
      {
        text: 'Покупатель'.toUpperCase(),
        value: 'CompanyName'
      },
      {
        text: 'ИНН'.toUpperCase(),
        value: 'VatNo'
      },
      {
        text: 'Доверенность'.toUpperCase(),
        value: 'Number'
      },
      {
        text: 'Статус'.toUpperCase(),
        value: 'Status'
      }
      ,
      {
        text: '',
        value: 'Id'
      }
      ,
      {
        text: '',
        value: 'DeleteId'
      }
    ],"paginate":_vm.count,"items":_vm.empowerments},on:{"paginateAction":_vm.paginate},scopedSlots:_vm._u([{key:"Id",fn:function(ref){
    var value = ref.value;
return [_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
    var on = ref.on;
    var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({attrs:{"icon":""},on:{"click":function($event){$event.stopPropagation();return _vm.handleRowClick(value)}}},'v-btn',attrs,false),on),[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v(" mdi-pen ")])],1)]}}],null,true)},[_c('span',[_vm._v("РЕДАКТИ́РОВАТЬ")])])]}},{key:"DeleteId",fn:function(ref){
    var value = ref.value;
return [_c('v-row',[_c('v-col',{attrs:{"md":"4","offset-md":"4"}},[_c('oil-modal',{attrs:{"value":value,"tooltipMessage":"УДАЛИТЬ","mdiIcon":"mdi-delete","accept":_vm.deleteEmpowerment}})],1)],1)]}}],null,false,824057562)})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }